import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { graphql, compose } from "react-apollo";
import { mutationAddCompanyColor, mutationAddCompanyNick } from "Apollo";
import Avatar from "module-common/Avatar";
import DeleteButton from "./DeleteButtonWithMutation";
import PickerColor from "module-common/PickerColor";
import Icon from "module-common/Icon";
import { ShowNotice } from "Store";

export default compose(
  graphql(mutationAddCompanyNick, {
    name: "mutationAddNickname"
  }),
  graphql(mutationAddCompanyColor, {
    name: "mutationAddColor"
  })
)(
  class Card extends Component {
    static propTypes = {
      id: PropTypes.number,
      name: PropTypes.string,
      displayName: PropTypes.string,
      displayPicture: PropTypes.string,
      dateCreated: PropTypes.object,
      channel: PropTypes.string,
      color: PropTypes.string,
      nickName: PropTypes.string
    };

    state = {
      editing: false,
      newNick: ""
    };

    render() {
      const {
        id,
        name,
        displayName,
        displayPicture,
        dateCreated,
        channel,
        color,
        nickName
      } = this.props;
      const { editing, newNick } = this.state;

      return (
        <Wrapper>
          <LeftColumn>
            <StyledAvatar image={displayPicture} channel={channel} />
            <DeleteButton id={id} />
          </LeftColumn>
          <RightColumn>
            <PickerColor onColorSelected={this.onChangeColor}>
              <LabelColor color={color} />
            </PickerColor>
            <Name>{name}</Name>
            <DisplayName>@{displayName}</DisplayName>
            <Date>Added at {dateCreated.format("DD/MM/YYYY")}</Date>
            <IconEdit name="edit" onClick={this.onEditClick} />
            {editing ? (
              <form onSubmit={this.onEditClick}>
                <TextInput
                  value={newNick}
                  onChange={e => this.setState({ newNick: e.target.value })}
                />
              </form>
            ) : (
              <NickName>{nickName}</NickName>
            )}
          </RightColumn>
        </Wrapper>
      );
    }

    onEditClick = () => {
      const editing = this.state.editing;
      if (editing) {
        // submit
        this.onUpdate();
        this.setState({ editing: false });
      } else {
        this.setState({ editing: true, newNick: this.props.nickName });
      }
    };

    onUpdate = () => {
      const { id, mutationAddNickname } = this.props;
      const { newNick } = this.state;
      try {
        mutationAddNickname({
          variables: {
            Id: id,
            NickNameInput: newNick
          }
        });
        refetchQueries: ["getCompanyChannelHandler"];
        ShowNotice("channel-nickname-success");
      } catch (error) {
        ShowNotice("channel-nickname-error");
      }
    };

    onChangeColor = async color => {
      const { id, mutationAddColor } = this.props;
      try {
        await mutationAddColor({
          variables: {
            Id: id,
            color: color.substr(1)
          }
        });
        refetchQueries: ["getCompanyChannelHandler"];
        ShowNotice("channel-color-success");
      } catch (error) {
        ShowNotice("channel-color-error");
      }
    };
  }
);

const Wrapper = styled.div`
  display: flex;
  width: 230px;
  height: 110px;
  border-radius: 4px;
  border: 1px solid ${props => props.theme.panelBorder};
  margin-right: 8px;
  margin-bottom: 8px;
  position: relative;
`;
const LeftColumn = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
  width: 70px;
  align-items: center;
  padding: 10px;
`;
const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
`;
const StyledAvatar = styled(Avatar)`
  margin-bottom: 15px;
`;
const DisplayName = styled.div`
  line-height: 1.2;
`;
const Name = styled.div`
  font-weight: bold;
  line-height: 1.2;
`;
const Date = styled.div`
  font-size: 0.7rem;
  margin-top: 8px;
  color: ${props => props.theme.uiText};
`;
const LabelColor = styled.div`
  position: absolute;
  right: 5px;
  top: 5px;
  flex: none;
  width: 12px;
  height: 12px;
  border: 1px solid ${props => props.theme.panelBorder};
  border-radius: 6px;
  ${props =>
    props.color &&
    css`
      background-color: ${props.color};
    `};
  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
`;

const TextInput = styled.input`
  width: 30%;
  padding: 4px;
  border: none;
  margin-top: 5px;
  border: 1px solid ${props => props.theme.panelBorder};
  border-radius: 3px;
  margin-left: 20px;
`;

const NickName = styled.div`
  width: 50%;
  padding: 4px;
  border: none;
  margin-top: 5px;
  margin-left: 20px;
`;

const IconEdit = styled(Icon)`
  position: absolute;
  bottom: 15px;
`;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/channel-panel/Card.js